<template>
  <div class="d-flex flex-wrap flex-md-nowrap mt-3 mb-3">
    <div class="me-0 me-md-3 mb-3 flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <button
        @click="navigatePrevious"
        :disabled="isBackButtonDiabled"
        v-show="!isFirst()"
        class="btn btn-red w-100"
      >
        {{ previousButtonText() }}
      </button>
    </div>
    <div class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <button @click="navigateNext" class="btn btn-red w-100" :disabled="isNextButtonDisabled">
        <!-- <button @click="navigateNext" class="btn btn-red w-100" :disabled="false"> -->
        {{ nextButtonText() }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
export default {
  props: ['invalid', 'validate'],
  methods: {
    ...mapActions(['verifyPage']),
    nextButtonText() {
      if (this.$store.state.page === 1) return 'Tovább';
      else if (this.$store.state.page === 2) return 'Tovább az összesítésre';
      // else if (this.$store.state.page === 3) return 'Tovább a szerződés adatokra';
      // else if (this.$store.state.page === 4) return 'Tovább az összesítésre';
      else return this.ifUniqueProcessType();
    },

    previousButtonText() {
      if (this.$store.state.page === 2) return 'Vissza';
      // else if (this.$store.state.page === 3) return 'Vissza a kiegészítőkre';
      // else if (this.$store.state.page === 4) return 'Vissza a kedvezményekre';
      else return 'Vissza a szerződés adatokra';
    },

    isFirst() {
      return this.$store.state.page === 1;
    },

    async navigateNext() {
      await this.validate();

      if (this.invalid) return;
      if (this.$store.state.page < 5) {
        this.$gtm.trackEvent({
          event: this.buttonEventName, // Event type [default = 'interaction'] (Optional)
          category: 'Calculator',
          action: 'click',
          label: this.buttonEventName,
          value: 5000,
          noninteraction: false, // Optional
        });
      }
      if (this.$store.state.page === 2) {
        setTimeout(() => {
          this.verifyPage(2);
        }, 5000);
      }
      if (this.$store.state.page === 3) {
        // if (!this.$store.state.canProceedToNextPage || this.invalid) return;
        // this.$gtm.trackEvent({
        //   event: this.buttonEventName, // Event type [default = 'interaction'] (Optional)
        //   transaction_id: this.$store.state.product_code,
        //   value: this.$store.state.kieg_emelt_eves_dij,
        //   discount: this.$store.getters.getDiscountSum, //Ez ne negatív szám éegyen *-1
        //   currency: 'HUF',
        //   coupon: this.$store.state.couponCode,
        //   category: 'Calculator',
        //   action: 'click',
        //   label: 'purchase',
        //   noninteraction: false, // Optional
        //   main_buildings_details: this.$store.getters.getMainBuildingDetails('P002'),
        //   side_buildings_details: this.$store.getters.getSideBuildingsDetails('P017'),
        //   items: this.$store.getters.getRisks,
        // });
        this.verifyPage(6);
        this.$store.commit('setFormSubmitLoading', true);
      } else {
        try {
          const {data: result} = await this.verifyPage(this.$store.state.page);

          if (
            result?.fieldErrors?.length <= 0 &&
            result?.generalErrors?.length <= 0 &&
            !this.invalid
          ) {
            this.$store.commit('incrementPage');
          }
        } catch (e) {
          console.error(e);
        }
      }
    },

    navigatePrevious() {
      this.$store.commit('decrementPage');
    },
    ifUniqueProcessType() {
      const isWallType = ['valyog', 'vegyes'].includes(
        this.$store.state.insuranceProperty.wallType
      );
      if (this.$store.state.generalInfo.propertyPhysicalJob === 1 || isWallType) {
        return 'Ajánlatot kérek';
      } else {
        return 'Csatlakozom a szerződéshez';
      }
    },
  },
  computed: {
    isBackButtonDiabled() {
      return this.$store.state.isBackButtonDisabled;
    },
    isNextButtonDisabled() {
      // return this.invalid;
      if (this.$store.state.page < 3) {
        return this.invalid;
      } else {
        return !this.$store.state.canProceedToNextPage || this.invalid;
      }
    },

    buttonEventName() {
      if (this.$store.state.page === 1) return 'accessories-next-click';
      if (this.$store.state.page === 2) return 'paymentSelection-next-click';
      if (this.$store.state.page === 3) return 'contractualData-next-click';
      if (this.$store.state.page === 4) return 'contractualSumary-next-click';
      if (this.$store.state.page === 5) return 'transaction-next-click';
    },
    ...mapFields(['generalInfo.chosenPackage']),
  },
};
</script>

<style lang="scss">
@media only screen and (min-width: 768px) {
  .w-md-auto {
    max-width: fit-content !important;
    width: auto !important;
  }
}
</style>
